module.exports = __webpack_public_path__ + "static/paintings-early-works-thumbnail-076d39810f68e2f1faf8ba61ab1ae66e.jpg";